import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { DATA_TYPE, MAX_LENGTH } from '../../../../../../constants/external-constants';
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';

class EquipmentAdditionalInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }

    render() {
        const {isCollapsed} = this.state;
        const { translator, rechargeInventoryDetails, rechargeInventoryDetailsForm } = this.props;

        console.log(rechargeInventoryDetailsForm);
        return (
            <div className="control-container">
                
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={() => {this.handleToggle()}} label={translator("additional_information", false)} >
                <div className={`add-sim-container detail-page-container details-4-col-container capital-uppercase`}>    
                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('requistion')}
                        value={rechargeInventoryDetailsForm.additionalInformation.requisition}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.requisition'
                        placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.limit_255}
                    />   

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('basket_requisition_number')}
                        value={rechargeInventoryDetailsForm.additionalInformation.basketRequisitionNumber}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.basketRequisitionNumber'
                        placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.limit_255}
                    />  

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('basket_number')}
                        value={rechargeInventoryDetailsForm.additionalInformation.basketNumber}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.basketNumber'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('basket_item_position')}
                        value={rechargeInventoryDetailsForm.additionalInformation.basketItemPosition}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.basketItemPosition'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('customer_tag')}
                        value={rechargeInventoryDetailsForm.additionalInformation.customerTag}
                        fieldProp='rechargeInventoryDetailsForm.additionalInformation.customerTag'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />
                </div>
            </CustomDropdown>
        </div>
        );
    }
}


export default withRouter(connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(EquipmentAdditionalInformation));